module.exports = __webpack_public_path__ + "static/img/13.010395d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/13.png
// module id = NQFZ
// module chunks = 0